import routes from 'sitewide-js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { NewsType } from '../shared/types';

type LegacyNewsfeedViewInput = {
  id: number | string;
  userId: number;
  createdAt: string;
  index: number;
};

export const legacyRecordNewsfeedView = async (
  currentUserId: number,
  newsType: NewsType,
  newsData: LegacyNewsfeedViewInput,
) => {
  const response = await fetchWithCsrf(
    routes.api_v0_active_support_notifications_path({
      subdomain_param: 'api',
    }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: 'individual_news_stories',
        user_id: currentUserId,
        viewed_at: new Date().getTime().toString(),
        stories: JSON.stringify([
          {
            timestamp: new Date(newsData.createdAt).getTime().toString(),
            position: newsData.index,
            entity_type: newsType,
            entity_id: newsData.id.toString(),
            actor_id: newsData.userId.toString(),
            actor_type: 'user',
          },
        ]),
      }),
    },
  );
  if (response.status !== 200) {
    throw new Error('Failed to report legacy newsfeed view');
  }
};
